import { Vocabulary } from "./Vocabulary";
import { urlEnum } from "./urlEnum";

export interface WebsiteModel {
  name: string;
  code: string;
  url: string;
  disabled?: boolean;
}

export const WEBSITE_INTEGRATIONS: WebsiteModel[] = [
  {
    name: Vocabulary.autodelrulate,
    code: "autodelrulate",
    url: urlEnum.postOnSite,
    disabled: true,
  },
  {
    name: Vocabulary.autovit,
    code: "autovit",
    url: urlEnum.autovit,
  },
  {
    name: Vocabulary.bestauto,
    code: "bestauto",
    url: urlEnum.bestauto,
  },
  {
    name: Vocabulary.plusAuto,
    code: "plusauto",
    url: urlEnum.plusAuto,
  },
  {
    name: Vocabulary.xauto,
    code: "xauto",
    url: urlEnum.xauto,
  },
  // {
  //   name: Vocabulary.autovit + ` (${Vocabulary.secondaryAccount})`,
  //   code: "autovit_secondary",
  //   url: urlEnum.autovit + "?account=autovit_secondary",
  // },
];

/**
 * Check if a vehicle is synced on a specific website
 * @param vehicle - Vehicle object
 * @param websiteCode - Website code (prefix)
 * @returns true if synced, false otherwise
 */
export const isVehicleSyncedOnWebsite = (
  vehicle: any,
  websiteCode: string,
): boolean => {
  if (!vehicle) return false;

  // For autodelrulate, check if slug exists and it hasn't been deactivated
  if (websiteCode === "autodelrulate") {
    return vehicle?.slug && !vehicle?.autodelrulate_deactivated_at ? true : false;
  }

  // For other websites, synced means advert_data exists and isn't marked deactivated
  const advertField = `${websiteCode.toLowerCase()}_advert_data`;
  const rawAdvertData = vehicle?.[advertField];
  if (!rawAdvertData) return false;

  const advertData =
    typeof rawAdvertData === "string" ? JSON.parse(rawAdvertData) : rawAdvertData;
  return advertData?.deactivated_at ? false : true;
};
